"use client"

import Script from "next/script"

interface GoogleAnalyticsProps {
  measurementId: string
}

/**
 * Injects the GA4 gtag.js snippet for a given Measurement ID.
 * measurementId is resolved server-side (see layout.tsx +
 * src/lib/pixel/ga.ts) so this component never makes an API call itself.
 * Page views are collected automatically by gtag; e-commerce events are
 * fired from the shared pixel tracking pipeline (lib/pixel/*).
 */
export default function GoogleAnalytics({ measurementId }: GoogleAnalyticsProps) {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
        strategy="afterInteractive"
      />
      <Script
        id="ga4-base"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${measurementId}');
          `,
        }}
      />
    </>
  )
}
